export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6989.cec35f2f.jpg";